import React, { useEffect, useState, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import apiService from "../../services/apiservice";
import { toast } from "react-toastify";
import moment from "moment";
import PatientSearch from "../Shared/patientSearch";
import PropTypes from 'prop-types';

const FilterEnquiry = ({ filterObj: initialFilterObj, onClear, onClose, mode }) => {
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);

  const [filterObj, setFilterObj] = useState(initialFilterObj || {});
  const [hospitalList, setHospitalList] = useState([]);
  const [ceUserList, setCeUserList] = useState([]);
  const [patientSearch, setPatientSearch] = useState(false);

  const serviceList = [
    { id: 8, value: "IPD" },
    { id: 9, value: "OPD" },
    { id: 10, value: "Investigation" },
    { id: 11, value: "Day Care" },
      { id: 12, value: 'Physiotherapy' },

  ];

  const conceirgStatusList = [
    { id: 1, value: "Patient Admitted" },
    { id: 2, value: "Patient Denied" },
    { id: 3, value: "Patient in OT" },
    { id: 4, value: "Patient Discharged" },
    { id: 5, value: "Hospital Denied" },
    { id: 6, value: "Patient is on the Way" },
    { id: 7, value: "Admission in Process" },
    { id: 8, value: "Patient in ICU" },
    { id: 9, value: "Patient in HDU" },
    { id: 10, value: "OT is scheduled Today" },
    { id: 11, value: "OT Cancelled" },
    { id: 12, value: "OT is Completed Today" },
    { id: 13, value: "Patient in Ward" },
    { id: 14, value: "Only OPD Done" },
    { id: 15, value: "Discharge is scheduled Today" }
  ];

  const statusList = [
    { id: 0, value: "Rejected" },
    { id: 1, value: "Under Process" },
    { id: 4, value: "Patient Denied" },
    { id: 5, value: "Hospital Denied" },
    { id: 6, value: "Procedure Confirmed" },
    { id: 12, value: "Waiting For Approval" },
    { id: 7, value: "Hold" },
  ];

  const traumaStatusMap = [
    { id: 0, value: "No" },
    { id: 1, value: "Yes (Waiting for Approval)" },
    { id: 2, value: "Yes (Approved)" },
    { id: 3, value: "Yes (Rejected)" },
  ];

  const campLeadOptions = [
    { id: 1, label: "Yes" },
    { id: 0, label: "No" },
  ];
  const feebacksentOptions = [
    { id: "YES", label: "Yes" },
    { id: "NO", label: "No" },
  ];
  const formatDate = (date) => moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : "";

  const parseDate = (dateString) => moment(dateString, "MM/DD/YYYY").isValid() ? new Date(dateString) : null;

  const handleChange = (e) => {
    const { name, value, id } = e.target;

    const isCreatedDate = ["fromDate1", "toDate1"].includes(name);
    const isModifiedDate = ["fromDate", "toDate"].includes(name);

    if (id === "date" && ((filterObj.fromDate && isCreatedDate) || (filterObj.fromDate1 && isModifiedDate))) {
      toast.error("Please clear the conflicting date filter");
      return;
    }

    const updatedValue = id === "date" ? formatDate(value) : value;

    if (name === "nameSearch" && value) {
      setFilterObj(prev => ({
        ...prev,
        [name]: value,
        patientName: "",
        patientId: ""
      }));
      return;
    }

    setFilterObj(prev => ({ ...prev, [name]: updatedValue }));
  };

  const handleSelectedData = ({ code, name }) => {
    setFilterObj(prev => ({
      ...prev,
      patientId: code,
      patientName: name,
      nameSearch: ""
    }));
    
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleCancel = () => {
    setFilterObj({});
    if (inputRef.current) inputRef.current.value = "";
    if (inputRef2.current) inputRef2.current.value = "";
    if (onClear) onClear();
  };

  const filterService = () => {
    if (onClose) onClose({ ...filterObj });
    setFilterObj({});
  };

  const toggleSidebar = () => setPatientSearch(prev => !prev);

  const getConciergeList = async () => {
    const payload = { roleCode: "CE", status: 1 };
    const res = await apiService.getUserList(payload);
    if (res.data.successList.length > 0) {
      setCeUserList(res.data.successList || []);
    }
  };

  const getHospitalList = async () => {
    const payload = { status: 1, HospitalType: "H" };
    const res = await apiService.getHospitalList(payload);
    const formatted = (res.data.successObject || []).map(el => ({
      ...el,
      hospitalLocationNames: `${el.hospitalName} (${el.name})`,
    }));
    setHospitalList(formatted);
  };

  const initializeDates = () => {
    const hasDates = filterObj.fromDate || filterObj.fromDate1;
    if (!hasDates) {
      const first = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      const last = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      setFilterObj(prev => ({
        ...prev,
        fromDate: formatDate(first),
        toDate: formatDate(last),
      }));
    }
  };

  const formatExistingDates = () => {
    if (filterObj.fromDate && filterObj.toDate) {
      setFilterObj(prev => ({
        ...prev,
        fromDate: formatDate(prev.fromDate),
        toDate: formatDate(prev.toDate),
      }));
    } else if (filterObj.fromDate1 && filterObj.toDate1) {
      setFilterObj(prev => ({
        ...prev,
        fromDate1: formatDate(prev.fromDate1),
        toDate1: formatDate(prev.toDate1),
      }));
    }
  };

  useEffect(() => {
    formatExistingDates();
    initializeDates();
    getConciergeList();
    getHospitalList();
  }, []);

  const handlePatientSelectClick = () => {
    toggleSidebar();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handlePatientSelectClick();
    }
  };

  const renderPatientSearchInput = () => (
    <div>
      <label htmlFor="patientSelect">Select Patient</label>
      <div className="relative">
        <InputText
          id="patientName"
          className="border border-gray-300 rounded-md p-2 pr-10 w-full"
          value={filterObj?.patientName || ''}
          name="patientName"
          placeholder="Click icon to search patients"
          readOnly
          ref={inputRef2}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer bg-transparent border-0"
          onClick={handlePatientSelectClick}
          onKeyPress={handleKeyPress}
          aria-label="Search patients"
          tabIndex={0}
        >
          <svg
            className="w-5 h-5 text-gray-400"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M21 21l-5.2-5.2"></path>
            <circle cx="10" cy="10" r="7"></circle>
          </svg>
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="grid mt-4 grid-cols-2 gap-4">
        <div>
          <label htmlFor="serviceEnquiryId">Enquiry Id</label>
          <div className="relative">
            <input
              id="id"
              name="id"
              className="border border-gray-300 rounded-md p-2 pr-10 w-full"
              onChange={handleChange}
              value={filterObj?.id || ''}
              placeholder="Search for Enquiry Id"
              type="number"
              pattern="\d*"
              ref={inputRef}
            />
          </div>
        </div>

        <div>
          <label htmlFor="dob">Enquiry Created From Date</label>
          <Calendar
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full"
            dateFormat="dd/mm/yy"
            style={{ height: "40px" }}
            onChange={handleChange}
            name="fromDate"
            value={parseDate(filterObj?.fromDate)}
            placeholder="Select From Date"
            disabled={!!filterObj.fromDate1 || !!filterObj.toDate1}
            maxDate={parseDate(filterObj.toDate)}
          />
        </div>
        <div>
          <label htmlFor="dob">Enquiry Created To Date</label>
          <Calendar
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full"
            dateFormat="dd/mm/yy"
            style={{ height: "40px" }}
            onChange={handleChange}
            name="toDate"
            value={parseDate(filterObj?.toDate)}
            placeholder="Select To Date"
            disabled={!!filterObj.fromDate1 || !!filterObj.toDate1}
            minDate={parseDate(filterObj.fromDate)}
          />
        </div>
        <div>
          <label htmlFor="dob">Enquiry Modified From Date</label>
          <Calendar
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full"
            dateFormat="dd/mm/yy"
            style={{ height: "40px" }}
            onChange={handleChange}
            value={parseDate(filterObj?.fromDate1)}
            placeholder="Select From Date"
            disabled={!!filterObj.fromDate || !!filterObj.toDate}
            maxDate={parseDate(filterObj.toDate1)}
            name="fromDate1"
          />
        </div>
        <div>
          <label htmlFor="dob">Enquiry Modified To Date</label>
          <Calendar
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full"
            dateFormat="dd/mm/yy"
            style={{ height: "40px" }}
            onChange={handleChange}
            name="toDate1"
            value={parseDate(filterObj?.toDate1)}
            placeholder="Select To Date"
            disabled={!!filterObj.fromDate || !!filterObj.toDate}
            minDate={parseDate(filterObj.fromDate1)}
          />
        </div>
        
        <div>
          <label htmlFor="nameSearch">Patient Name</label>
          <div className="relative">
            <input
              id="nameSearch"
              name="nameSearch"
              className="border border-gray-300 rounded-md p-2 pr-10 w-full"
              onChange={handleChange}
              value={filterObj?.nameSearch || ''}
              placeholder="Search by patient name"
              type="text"
              ref={inputRef}
            />
          </div>
        </div>
        
        {renderPatientSearchInput()}
        
        <div>
          <label htmlFor="name">Preferred Hospitals</label>
          <Dropdown
            optionLabel="hospitalLocationNames"
            placeholder="Select Preferred Hospitals"
            options={hospitalList}
            name="preferredHospitalAndClinics"
            value={filterObj?.preferredHospitalAndClinics}
            optionValue="hospitalCode"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
            filter
          />
        </div>
        <div>
          <label htmlFor="name">Service Type</label>
          <Dropdown
            optionLabel="value"
            placeholder="Select Service Type"
            options={serviceList}
            name="serviceType"
            value={filterObj?.serviceType}
            optionValue="id"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="dob">Procedure Planned Date</label>
          <Calendar
            id="date"
            className="border border-gray-300 rounded-md p-2 w-full"
            dateFormat="dd/mm/yy"
            style={{ height: "40px" }}
            onChange={handleChange}
            name="procedurePlannedDate"
            placeholder="Select Procedure Planned date"
            value={parseDate(filterObj?.procedurePlannedDate)}
          />
        </div>
        {mode !== "New" && (
          <div>
            <label htmlFor="name">Status</label>
            <Dropdown
              optionLabel="value"
              placeholder="Select Status"
              options={statusList}
              name="status"
              value={filterObj?.status}
              optionValue="id"
              className="border border-gray-300 rounded-md w-full"
              onChange={handleChange}
            />
          </div>
        )}
        <div>
          <label htmlFor="name">Concierge Executive</label>
          <Dropdown
            value={filterObj?.conciergeUserCode}
            options={ceUserList}
            optionLabel="userName"
            placeholder="Select a Concierge Executive"
            optionValue="code"
            name="conciergeUserCode"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="name">Concierge Status</label>
          <Dropdown
            value={filterObj?.conciergeStatus}
            options={conceirgStatusList}
            optionLabel="value"
            placeholder="Select a Concierge Status"
            optionValue="id"
            name="conciergeStatus"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="name">Trauma Status</label>
          <Dropdown
            optionLabel="value"
            placeholder="Select Trauma Status"
            options={traumaStatusMap}
            name="traumaStatus"
            value={filterObj?.traumaStatus}
            optionValue="id"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="name">CAMP LEAD</label>
          <Dropdown
            optionLabel="label"
            placeholder="Select Camp lead or Not"
            options={campLeadOptions}
            value={filterObj?.campLead}
            optionValue="id"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
            name="campLead"
            filter
          />
        </div>
                <div>
          <label htmlFor="name">Feedback Message Status</label>
          <Dropdown
            optionLabel="label"
            placeholder="Select Feedback Status"
            options={feebacksentOptions}
            value={filterObj?.feedbackMsgStatus}
            optionValue="id"
            className="border border-gray-300 rounded-md w-full"
            onChange={handleChange}
            name="feedbackMsgStatus"
            filter
          />
        </div>
      </div>
      <div className="grid mt-36 ml-12 grid-cols-2 gap-4">
        <div>
          <button
            className="h-9 bg-[#004172] text-white rounded-md w-full"
            onClick={filterService}
          >
            Ok
          </button>
        </div>
        <div>
          <button
            className="h-9 border border-[#004172] text-[#004172] font-bold font-monospace rounded-md w-full"
            onClick={handleCancel}
          >
            Clear
          </button>
        </div>
      </div>
      <PatientSearch
        showbar={patientSearch}
        setshowBar={toggleSidebar}
        onSelect={handleSelectedData}
      />
    </>
  );
};

FilterEnquiry.propTypes = {
  filterObj: PropTypes.object,
  onClear: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.string,
};

FilterEnquiry.defaultProps = {
  filterObj: {},
  mode: "",
  onClear: () => {},
};

export default FilterEnquiry;